// The copy of the return window field and its rows.
export const NS = 'returns_refunds.return_window'

// Local dates for the calendar: a YYYY-MM-DD read as UTC would show the previous day west of Greenwich.
export function toDate(iso: string): Date | undefined {
  if (!iso) return undefined
  const [year, month, day] = iso.split('-').map(Number)
  return new Date(year, month - 1, day)
}

export function toIso(date: Date | undefined): string {
  if (!date) return ''
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}

const DAY: Intl.DateTimeFormatOptions = {
  day: 'numeric',
  month: 'short',
  year: 'numeric'
}

export const formatDay = (iso: string, locale: string) =>
  new Intl.DateTimeFormat(locale, DAY).format(toDate(iso))

export const formatRange = (start: string, end: string, locale: string) =>
  new Intl.DateTimeFormat(locale, DAY).formatRange(
    toDate(start) as Date,
    toDate(end) as Date
  )
